import React, { useState, useEffect, memo } from "react";
import dayjs from "dayjs";
import "./TimeAlert.scss";
import "../EditOtsForm/EventDetailsHeader.scss";

interface TimeAlertProps {
    AdviseTimeUTC: string;
    ADVBump: number;
    EstimatedReturnToServiceTimeUTC: string;
    ETRBump: number;
    compName: string;
}

const TimeAlert = (props: TimeAlertProps) => {
    const { AdviseTimeUTC, ADVBump, EstimatedReturnToServiceTimeUTC, ETRBump,compName} = props;
    const [currenttime, Setcurrenttime] = useState();
    const [advColor, SetadvColor] = useState("");
    const [displaydate, Setdisplaydate] = useState(false);
    const [Etd, ShowEtd] = useState(false);
    let BLUE = "blue";
    let YELLOW = "yellow";
    let RED = "red";

    useEffect(() => {
        let isMounted = true;
      
        if (isMounted && (AdviseTimeUTC || EstimatedReturnToServiceTimeUTC)) {
            calculatehours();
        }
        const interval = setInterval(() => {
          if (isMounted && (AdviseTimeUTC || EstimatedReturnToServiceTimeUTC)) {
            calculatehours();
          }
        }, 1000);
      
        return () => {
          clearInterval(interval);
          isMounted = false;
        };
      }, [AdviseTimeUTC, EstimatedReturnToServiceTimeUTC]);

    function Checkifprevday(pTime, place) {
        let input = dayjs(pTime);
        const cond1 = dayjs().format('YYYY') == input.format('YYYY') && dayjs().format('MM') == input.format('MM') && dayjs().format('DD') == input.format('DD') - 1;
        const cond2 = dayjs().format('YYYY') == input.format('YYYY') && (dayjs().format('MM') < input.format('MM') && input.format('DD') == "01" && (dayjs().format('DD') == "30" || dayjs().format('DD') == "31"));
        if (place == "NON") {
            Setdisplaydate(cond1 || cond2);
        }
        else if (place == "ETD") {
            ShowEtd(cond1 || cond2);
        }

    }


    const calculaterealtime = (pTime) => {
        let diffsec = pTime.diff(dayjs(), 'second');
        let daydiff = pTime.diff(dayjs(), 'day') > 0;
        let sameDay = Number(pTime.format('DD')) - 1 == Number(dayjs().format('DD'));
        if (diffsec < 300 && diffsec >= 0) {
            SetadvColor(YELLOW);
        }
        else if (diffsec > 300 && (daydiff || sameDay)) {
            SetadvColor(BLUE);
        }
        else if (diffsec < 0) {
            SetadvColor(RED);
        }
        else {
            SetadvColor("");
        }

        Checkifprevday(pTime, "NON");
    }


    const calculatehours = () => {
        Setcurrenttime(dayjs());
        let calcTime;
        if (AdviseTimeUTC) {
            calcTime = dayjs(AdviseTimeUTC);
        }
        else {
            calcTime = dayjs(EstimatedReturnToServiceTimeUTC);
        }
        calculaterealtime(calcTime);
    }

    const formatTime = (inputTime: string, isTime: boolean): string => {
        const convertedTime = dayjs.utc(inputTime).local();
        return isTime ? convertedTime.format("HH:mm") : convertedTime.format("MM/DD/YY");
    };

    return (
        <>
            {compName === 'EventDetailsHeader' ? (
                <div className={`event-details-action-block adv-time-${advColor}`}>
                    <div className={`event-details-header-label adv-color-${advColor}`}>
                        {advColor === '' ?
                            <span>{AdviseTimeUTC ? <span>ADV</span> : <span>ETR</span>}</span> :
                            <span className={advColor === '' ? '' : 'adv-icon-spacing'} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.9987 1.83203C11.6806 1.83203 14.6654 4.8168 14.6654 8.4987C14.6654 12.1806 11.6806 15.1654 7.9987 15.1654C4.3168 15.1654 1.33203 12.1806 1.33203 8.4987C1.33203 4.8168 4.3168 1.83203 7.9987 1.83203ZM7.9987 2.83203C4.86908 2.83203 2.33203 5.36908 2.33203 8.4987C2.33203 11.6283 4.86908 14.1654 7.9987 14.1654C11.1283 14.1654 13.6654 11.6283 13.6654 8.4987C13.6654 5.36908 11.1283 2.83203 7.9987 2.83203ZM7.9987 10.832C8.27484 10.832 8.4987 11.0559 8.4987 11.332C8.4987 11.6082 8.27484 11.832 7.9987 11.832C7.72256 11.832 7.4987 11.6082 7.4987 11.332C7.4987 11.0559 7.72256 10.832 7.9987 10.832ZM7.9987 5.16536C8.25183 5.16536 8.46103 5.35347 8.49413 5.59752L8.4987 5.66536V9.83203C8.4987 10.1082 8.27484 10.332 7.9987 10.332C7.74557 10.332 7.53637 10.1439 7.50326 9.89988L7.4987 9.83203V5.66536C7.4987 5.38922 7.72256 5.16536 7.9987 5.16536Z" fill="white" />
                                </svg>
                                <span className={advColor === '' ? '' : 'adv-label-spacing'} >{AdviseTimeUTC ? <span>ADV</span> : <span>ETR</span>}</span>
                            </span>
                        }
                    </div>
                    <div className={`event-details-header-text adv-color-${advColor}`}>
                        {AdviseTimeUTC ?
                            <span className={advColor === '' ? '' : 'adv-text-spacing'}>{formatTime(AdviseTimeUTC, true)} . {formatTime(AdviseTimeUTC, false)} ({ADVBump})</span>
                            : <span className={advColor === '' ? '' : 'adv-text-spacing'}>{formatTime(EstimatedReturnToServiceTimeUTC, true)} . {formatTime(EstimatedReturnToServiceTimeUTC, false)} ({ETRBump})</span>}
                    </div>
                </div>
            ): (
                    <div className = {`timealert_container adv-time-${advColor}`}>
                <div className="head_container_alert"> {<span>
                    {advColor != "" &&
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="alert/warning-stroke">
                                <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M8.0026 2C11.6845 2 14.6693 4.98477 14.6693 8.66667C14.6693 12.3486 11.6845 15.3333 8.0026 15.3333C4.32071 15.3333 1.33594 12.3486 1.33594 8.66667C1.33594 4.98477 4.32071 2 8.0026 2ZM8.0026 3C4.87299 3 2.33594 5.53705 2.33594 8.66667C2.33594 11.7963 4.87299 14.3333 8.0026 14.3333C11.1322 14.3333 13.6693 11.7963 13.6693 8.66667C13.6693 5.53705 11.1322 3 8.0026 3ZM8.0026 11C8.27875 11 8.5026 11.2239 8.5026 11.5C8.5026 11.7761 8.27875 12 8.0026 12C7.72646 12 7.5026 11.7761 7.5026 11.5C7.5026 11.2239 7.72646 11 8.0026 11ZM8.0026 5.33333C8.25573 5.33333 8.46493 5.52144 8.49804 5.76549L8.5026 5.83333V10C8.5026 10.2761 8.27875 10.5 8.0026 10.5C7.74947 10.5 7.54028 10.3119 7.50717 10.0678L7.5026 10V5.83333C7.5026 5.55719 7.72646 5.33333 8.0026 5.33333Z" fill="white" />
                            </g>
                        </svg>

                    }
                    {
                        advColor == "" && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="alert/warning-stroke">
                                <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M7.9987 1.66797C11.6806 1.66797 14.6654 4.65274 14.6654 8.33464C14.6654 12.0165 11.6806 15.0013 7.9987 15.0013C4.3168 15.0013 1.33203 12.0165 1.33203 8.33464C1.33203 4.65274 4.3168 1.66797 7.9987 1.66797ZM7.9987 2.66797C4.86908 2.66797 2.33203 5.20502 2.33203 8.33464C2.33203 11.4642 4.86908 14.0013 7.9987 14.0013C11.1283 14.0013 13.6654 11.4642 13.6654 8.33464C13.6654 5.20502 11.1283 2.66797 7.9987 2.66797ZM7.9987 10.668C8.27484 10.668 8.4987 10.8918 8.4987 11.168C8.4987 11.4441 8.27484 11.668 7.9987 11.668C7.72256 11.668 7.4987 11.4441 7.4987 11.168C7.4987 10.8918 7.72256 10.668 7.9987 10.668ZM7.9987 5.0013C8.25183 5.0013 8.46103 5.1894 8.49413 5.43346L8.4987 5.5013V9.66797C8.4987 9.94411 8.27484 10.168 7.9987 10.168C7.74557 10.168 7.53637 9.97987 7.50326 9.73582L7.4987 9.66797V5.5013C7.4987 5.22516 7.72256 5.0013 7.9987 5.0013Z" fill="#00274A" />
                            </g>
                        </svg>

                    }
                </span>}
                    <span className={advColor != "" ? "title_timealert" : "title_timealert title-edit "}>{AdviseTimeUTC == null || AdviseTimeUTC == "" ? "ETR" : "ADV"}:</span></div>
                <div className="timealert_details">
                    <div className={advColor !== "" ? "details_container" : "details_container default_detail_container"}>
                        <span>
                            {AdviseTimeUTC ? formatTime(AdviseTimeUTC, true) : formatTime(EstimatedReturnToServiceTimeUTC, true)}</span>
                        <span></span>{AdviseTimeUTC ? formatTime(AdviseTimeUTC, false) : formatTime(EstimatedReturnToServiceTimeUTC, false)}
                        <span> {AdviseTimeUTC ? "(" + ADVBump + ")" : "(" + ETRBump + ")"}</span>
                    </div>

                </div>
        </div >
        )}
        </>
    )
}

export default memo(TimeAlert);